import {
  createThreadBehaviour,
  type ResponderDraftEvent,
} from './shared-responder-v2-core-thread-behaviour';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';
import type { ResponderAnswer } from './shared-responder-v2-core-thread.types';

export function emptyTaskDraft(): ResponderAnswer {
  return { kind: 'acknowledged', transcript: null };
}

export function reduceTaskDraft(
  draft: ResponderAnswer | null,
  event: ResponderDraftEvent
): ResponderAnswer | null {
  if (event.type === 'acknowledged') {
    return {
      kind: 'acknowledged',
      transcript: draft?.kind === 'acknowledged' ? draft.transcript : null,
    };
  }

  if (event.type === 'transcriptChanged') {
    return { kind: 'acknowledged', transcript: event.transcript };
  }

  return draft;
}

/**
 * A responder must never be forced to type an answer to a task — the
 * affordance is "When you have completed the task, click or say continue".
 * Completion is self-reported, so the draft is never blocking.
 *
 * Opening the site is the one thing a task does hold the responder for, and it
 * is deliberately not expressed here: a draft rule sees only the draft and the
 * spec, while the visit is recorded on the thread, so `isSiteGateBlocking` owns
 * that axis.
 */
export const TASK_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.Task,
  isAnswerEditable: false,
  recordsVoiceWhenUrlPresent: false,
  retainsServerFollowUps: true,
  emptyDraft: emptyTaskDraft,
  reduceDraft: reduceTaskDraft,
  isDraftComplete: () => true,
  showsContinueButton: () => true,
});
